import RatioProps from './RatioProps';

const ratio: RatioProps = {
  portrait: {
    value: '1/1',
    get query() {
      return `max-aspect-ratio: ${this.value}`;
    },
    get mediaQuery() {
      return `@media (${this.query})`;
    },
  },
  landscape: {
    value: '1/1',
    get query() {
      return `min-aspect-ratio: ${this.value}`;
    },
    get mediaQuery() {
      return `@media (${this.query})`;
    },
  },
};

export default ratio;
